export { default } from './isHostComponent';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/isHostComponent/index.js
// module id = 136
// module chunks = 22